import React from 'react';
import {Form} from 'react-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { resetTonalityFilter, setTonalityFilter } from '../../../actions/filters';

class TonalityFilter extends React.Component {
  state = {
    filter: this.props.difficultyFilter,
  };

  componentWillUnmount() {
    this.props.resetTonalityFilter();
  }

  handleFilterChange = (event) => {
    let filter = parseInt(event.currentTarget.value);
    this.setState({filter});
    this.props.setTonalityFilter(filter);
  };

  render() {
    const options = this.props.tonalities.map(i => <option value={ i.value }>{ i.label }</option>);
    return <Form.Group controlId="filter.tonality">
      <Form.Label>{ gettext('Тональность') }</Form.Label>
      <Form.Control as='select' size='sm' value={ this.state.filter } onChange={ this.handleFilterChange }>
        <option value={0}>{ gettext('Все') }</option>
        { options }
      </Form.Control>
    </Form.Group>
  }
}

let mapStateToProps = (state) => {
  return {
    tonalityFilter: state.filters.tonalityFilter,
    tonalities: state.shop.tonalities,
  }
};

export default compose(connect(
  mapStateToProps,
  {
    setTonalityFilter, resetTonalityFilter
  }))
(TonalityFilter)

